// @ts-nocheck

import * as React from 'react';

export const hilightedTableRow = {
  backgroundColor: 'rgba(2, 187, 241, 0.05)', // using rgba as an exception to simply integrate with SmartTableRow <tr>
};
